import React from "react";
import Login from "../pages/auth/Login";
import ErrorPage from "../pages/Error";
import RootLayout from "../pages/RootLayout";
import Dashboard from "../pages/Dashboard";
import RestaurantView from "../pages/restaurant/RestaurantView";
import RestaurantAdd from "../pages/restaurant/RestaurantAdd";
import RestaurantDetail from "../pages/restaurant/RestaurantDetail";
import RestaurantEdit from "../pages/restaurant/RestaurantEdit";
import RestaurantManageOwners from "../pages/restaurant/RestaurantManageOwners";
import BranchView from "../pages/branch/BranchView";
import BranchAdd from "../pages/branch/BranchAdd";
import BranchDetail from "../pages/branch/BranchDetail";
import BranchEdit from "../pages/branch/BranchEdit";
import BranchManageOwners from "../pages/branch/BranchManageOwners";
import BranchSubscriptionView from "../pages/branchSubscription/BranchSubscriptionView";
import AssignBranchSubscription from "../pages/branchSubscription/AssignBranchSubscription";
import BranchSubscriptionDetail from "../pages/branchSubscription/BranchSubscriptionDetail";
import UserView from "../pages/user/UserView";
import UserAdd from "../pages/user/UserAdd";
import UserDetail from "../pages/user/UserDetail";
import UserEdit from "../pages/user/UserEdit";
import TagView from "../pages/tag/TagView";
import TagUpdate from "../pages/tag/TagUpdate";
import TagDetail from "../pages/tag/TagDetail";
import TagEdit from "../pages/tag/TagEdit";
import ProductView from "../pages/product/ProductView";
import ProductUpdate from "../pages/product/ProductUpdate";
import ProductDetail from "../pages/product/ProductDetail";
import ProductEdit from "../pages/product/ProductEdit";
import OrderView from "../pages/order/OrderView";
import OrderAdd from "../pages/order/OrderAdd";
import Profile from "../pages/Profile";
import EmployeeView from "../pages/employee/EmployeeView";
import EmployeeAdd from "../pages/employee/EmployeeAdd";
import EmployeeDetail from "../pages/employee/EmployeeDetail";
import EmployeeEdit from "../pages/employee/EmployeeEdit";
import CustomerView from "../pages/customer/CustomerView";
import CustomerDetail from "../pages/customer/CustomerDetail";
import CustomerEdit from "../pages/customer/CustomerEdit";
import CustomerAdd from "../pages/customer/CustomerAdd";
import DiscountAdd from "../pages/customerDiscount/DiscountAdd";
import DiscountView from "../pages/customerDiscount/DiscountView";
import CustomerOrder from "../pages/customer/CustomerOrder";
import VendorView from "../pages/vendor/VendorView";
import VendorAdd from "../pages/vendor/VendorAdd";
import VendorDetail from "../pages/vendor/VendorDetail";
import VendorEdit from "../pages/vendor/VendorEdit";
import PurchaseAdd from "../pages/purchase/PurchaseAdd";
import PurchaseView from "../pages/purchase/PurchaseView";
import VendorDues from "../pages/vendor/VendorDues";
import PurchaseDetail from "../pages/purchase/PurchaseDetail";
import DiscountDetail from "../pages/customerDiscount/DiscountDetail";
import VendorPaymentHistory from "../pages/vendor/VendorPaymentHistory";
import PurchaseViewVendor from "../pages/purchase/PurchaseViewVendor";
import ViewInternalOrder from "../pages/internalOrder/ViewInternalOrder";
import AddInternalOrder from "../pages/internalOrder/AddInternalOrder";
import DetailInternalOrder from "../pages/internalOrder/DetailInternalOrder";
import ProductHistory from "../pages/product/ProductHistory";
import OrderDetail from "../pages/order/OrderDetail";
import TagAdd from "../pages/tag/TagAdd";
import TagAssign from "../pages/tag/TagAssign";
import OrderEdit from "../pages/order/OrderEdit";
import ProductReport from "../pages/report/ProductReport";
import TransactionTypeView from "../pages/transactionType/TransactionTypeView";
import TransactionTypeAdd from "../pages/transactionType/TransactionTypeAdd";
import TransactionTypeEdit from "../pages/transactionType/TransactionTypeEdit";
import TransactionTypeDetail from "../pages/transactionType/TransactionTypeDetail";
import FinancialReport from "../pages/report/FinancialReport";
import TransactionView from "../pages/transaction/TransactionView";
import TransactionAdd from "../pages/transaction/TransactionAdd";
import TransactionDetail from "../pages/transaction/TransactionDetail";
import TransactionEdit from "../pages/transaction/TransactionEdit";
import IncomeProductAdd from "../pages/incomeProduct/IncomeProductAdd";
import IncomeProductView from "../pages/incomeProduct/IncomeProductView";
import ExpenseProductAdd from "../pages/expenseProduct/ExpenseProductAdd";
import ExpenseProductView from "../pages/expenseProduct/ExpenseProductView";
import IncomeProductEdit from "../pages/incomeProduct/IncomeProductEdit";
import IncomeProductDetail from "../pages/incomeProduct/IncomeProductDetail";
import ExpenseProductDetail from "../pages/expenseProduct/ExpenseProductDetail";
import ExpenseProductEdit from "../pages/expenseProduct/ExpenseProductEdit";
import RecurringExpenseView from "../pages/recurringExpense/RecurringExpenseView";
import RecurringExpenseAdd from "../pages/recurringExpense/RecurringExpenseAdd";
import RecurringExpenseDetail from "../pages/recurringExpense/RecurringExpenseDetail";
import RecurringExpenseEdit from "../pages/recurringExpense/RecurringExpenseEdit";
import EmployeeAssign from "../pages/employee/EmployeeAssign";
import ProductManage from "../pages/product/ProductManage";
import CustomerTransactions from "../pages/customer/CustomerTransactions";
import ProductStockAlert from "../pages/product/ProductStockAlert";
import CreateInvoice from "../pages/Invoice/CreateInvoice";
import Setting from "../pages/setting/Setting";
import BankAdd from "../pages/bank/BankAdd";
import BankView from "../pages/bank/BankView";
import BankEdit from "../pages/bank/BankEdit";
import BankDetail from "../pages/bank/Bank Detail";
import ViewInvoice from "../pages/Invoice/ViewInvoice";
import DetailedInvoice from "../pages/Invoice/DetailedInvoice";
import VendorDocAttach from "../pages/vendor/VendorDocAttach";
import VendorLogin from "../pages/auth/VendorLogin";
import VendorLayout from "../pages/VendorLayout";
import VendorDocHistory from "../pages/vendor/VendorDocHistory";
import VendorDeveloperView from "../pages/vendor/VendorDeveloperView";
import ContactView from "../pages/contact/ContactView";
import ContactDetail from "../pages/contact/ContactDetail";
import TrackOrder from "../pages/order/TrackOrder";
import ProductRecommendation from "../pages/product/ProductRecommendation";
import NewOrders from "../pages/order/NewOrders";
import CompletedOrders from "../pages/order/CompletedOrders";
import RejectedOrders from "../pages/order/RejectedOrders";
// import BuildingAdd from "../pages/building/BuildingAdd";
// import BuildingView from "../pages/building/BuildingView";
// import BuildingDetail from "../pages/building/BuildingDetail";
// import BuildingEdit from "../pages/building/BuildingEdit";

export const routes = [
    {
        path: "/",
        element: <RootLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Dashboard />,
                permissions: ['SuperAdmin', 'RestaurantAdmin', 'RestaurantOwner', 'BranchAdmin', 'BranchOwner', 'BranchManager', 'BranchEmployee'],
            },
            {
                path: 'tag',
                permissions: ['RestaurantAdmin', 'RestaurantOwner', 'BranchAdmin', 'BranchOwner'],
                children: [
                    { index: true, element: <TagView /> },
                    {
                        path: 'update',
                        permissions: ['BranchAdmin', 'BranchOwner'],
                        element: <TagUpdate />
                    },
                    { path: 'add', element: <TagAdd /> },
                    {
                        path: ':tagId',
                        children: [
                            { index: true, element: <TagDetail /> },
                            { path: 'edit', element: <TagEdit /> },
                            { path: 'assign/:tag', element: <TagAssign /> }
                        ]
                    }
                ],
            },
            {
                path: 'product',
                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                children: [
                    { index: true, element: <ProductView /> },
                    {
                        path: 'update',
                        permissions: ['BranchAdmin', 'BranchOwner'],
                        element: <ProductUpdate />
                    },
                    {
                        path: 'manage',
                        permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                        element: <ProductManage />
                    },
                    {
                        path: 'recommended',
                        permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                        element: <ProductRecommendation />
                    },
                    {
                        path: 'alert',
                        permissions: ['BranchAdmin', 'BranchOwner'],
                        element: <ProductStockAlert />
                    },
                    {
                        path: ':productId',
                        children: [
                            { index: true, element: <ProductDetail /> },
                            { path: 'edit', element: <ProductEdit /> },
                            { path: 'history', element: <ProductHistory /> },
                        ]
                    }
                ]
            },
            {
                path: 'income',
                permissions: ['RestaurantAdmin', 'RestaurantOwner'],
                children: [
                    { index: true, element: <></> },
                    {
                        path: ':incomeType',
                        children: [
                            { index: true, element: <IncomeProductView /> },
                            { path: 'add', element: <IncomeProductAdd /> },
                            {
                                path: ':productId',
                                children: [
                                    { index: true, element: <IncomeProductDetail /> },
                                    { path: 'edit', element: <IncomeProductEdit /> },
                                ]
                            },
                        ]
                    }
                ]
            },
            {
                path: 'expense',
                permissions: ['RestaurantAdmin', 'RestaurantOwner'],
                children: [
                    { index: true, element: <></> },
                    {
                        path: ':expenseType',
                        children: [
                            { index: true, element: <ExpenseProductView /> },
                            { path: 'add', element: <ExpenseProductAdd /> },
                            {
                                path: ':productId',
                                children: [
                                    { index: true, element: <ExpenseProductDetail /> },
                                    { path: 'edit', element: <ExpenseProductEdit /> },
                                ]
                            },
                        ]
                    }
                ]
            },
            {
                path: 'restaurant',
                permissions: ['SuperAdmin'],
                children: [
                    { index: true, element: <RestaurantView /> },
                    { path: 'add', element: <RestaurantAdd /> },
                    {
                        path: ':restaurantId',
                        children: [
                            { index: true, element: <RestaurantDetail /> },
                            { path: 'edit', element: <RestaurantEdit /> },
                            { path: 'manage-owners', element: <RestaurantManageOwners /> },
                        ]
                    }
                ]
            },
            {
                path: 'branch',
                permissions: ['SuperAdmin'],
                children: [
                    { index: true, element: <BranchView /> },
                    { path: 'add', element: <BranchAdd /> },
                    {
                        path: ':branchId',
                        children: [
                            { index: true, element: <BranchDetail /> },
                            { path: 'edit', element: <BranchEdit /> },
                            { path: 'manage-owners', element: <BranchManageOwners /> },
                        ]
                    }
                ]
            },
            {
                path: 'subscription',
                permissions: ['SuperAdmin'],
                children: [
                    { index: true, element: <BranchSubscriptionView /> },
                    { path: 'add', element: <AssignBranchSubscription /> },
                    {
                        path: ':globalBranchSubscription',
                        children: [
                            { index: true, element: <BranchSubscriptionDetail /> },
                        ]
                    }
                ]
            },
            {
                path: 'user',
                permissions: ['SuperAdmin'],
                children: [
                    { index: true, element: <UserView /> },
                    { path: 'add', element: <UserAdd /> },
                    {
                        path: ':userId',
                        children: [
                            { index: true, element: <UserDetail /> },
                            { path: 'edit', element: <UserEdit /> }
                        ]
                    }
                ]
            },
            {
                path: "order",
                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager', 'BranchEmployee'],
                children: [
                    { index: true, element: <OrderView /> },
                    {
                        path: "add",
                        permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                        element: <OrderAdd />
                    },
                    {
                        path: ":orderId",
                        permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                        children: [
                            { index: true, element: <OrderDetail /> },
                            { path: 'edit', element: <OrderEdit /> },
                        ]
                    },
                    {
                        path: "new",
                        permissions: ['BranchEmployee'],
                        element: <NewOrders/>
                    },
                    {
                        path: "rejected",
                        permissions: ['BranchEmployee'],
                        element: <RejectedOrders/>
                    },
                    {
                        path: "completed",
                        permissions: ['BranchEmployee'],
                        element: <CompletedOrders/>
                    }
                ],
            },
            {
                path: "employee",
                permissions: ['BranchAdmin', 'BranchOwner'],
                children: [
                    { index: true, element: <EmployeeView /> },
                    {
                        path: "add",
                        element: <EmployeeAdd />
                    },
                    {
                        path: ':employeeId',
                        children: [
                            { index: true, element: <EmployeeDetail /> },
                            { path: 'edit', element: <EmployeeEdit /> },
                            { path: 'assignEmployee/:employeeName', element: <EmployeeAssign /> }
                        ]
                    }
                ],
            },
            {
                path: "customer",
                permissions: ['BranchAdmin', 'BranchOwner'],
                children: [
                    { index: true, element: <CustomerView /> },
                    {
                        path: "add",
                        element: <CustomerAdd />
                    },
                    {
                        path: ':customerId',
                        children: [
                            { index: true, element: <CustomerDetail /> },
                            { path: 'customerOrder', element: <CustomerOrder /> },
                            { path: 'customerTransaction/:customer', element: <CustomerTransactions /> },
                            { path: 'edit', element: <CustomerEdit /> },
                            { path: 'addDiscount', element: <DiscountAdd /> },
                            { path: 'editDiscount/:discountId', element: <DiscountAdd /> },
                        ]
                    }
                ],
            },
            {
                path: "vendor",
                permissions: ['BranchAdmin', 'BranchOwner'],
                children: [
                    { index: true, element: <VendorView /> },
                    { path: "vendorDeveloperView", element: <VendorDeveloperView /> },
                    {
                        path: "add",
                        element: <VendorAdd />
                    },
                    {
                        path: ':vendorId',
                        children: [
                            { index: true, element: <VendorDetail /> },
                            {
                                path: 'edit',
                                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                                element: <VendorEdit />
                            },
                            { path: 'getDue', permissions: ['BranchAdmin', 'BranchOwner'], element: <VendorDues /> },
                            {
                                path: 'history',
                                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                                element: <VendorPaymentHistory />
                            },
                            {
                                path: 'purchase',
                                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                                children: [
                                    { index: true, element: <PurchaseViewVendor /> },
                                    { path: 'add', element: <PurchaseAdd /> },
                                    { path: ':purchaseId/add', element: <PurchaseAdd /> },
                                    { path: ':purchaseId/edit', element: <PurchaseAdd /> },
                                    { path: ':purchaseId', element: <PurchaseDetail /> },
                                ]
                            }
                        ]
                    }
                ],
            },
            {
                path: "purchase",
                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                children: [
                    { index: true, element: <PurchaseView /> },
                    {
                        path: "add",
                        element: <PurchaseAdd />
                    },
                    {
                        path: ':purchaseId',
                        children: [
                            { index: true, element: <PurchaseDetail /> },
                            { path: 'add', element: <PurchaseAdd /> },
                            { path: 'edit', element: <PurchaseAdd /> }
                        ]
                    }
                ],
            },
            {
                path: "internalOrder",
                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                children: [
                    { index: true, element: <ViewInternalOrder /> },
                    {
                        path: "add",
                        element: <AddInternalOrder />
                    },
                    {
                        path: ':interOrderId',
                        children: [
                            { index: true, element: <DetailInternalOrder /> },
                            { path: 'edit', element: <AddInternalOrder /> }
                        ]
                    }
                ],
            },
            {
                path: "report",
                permissions: ['BranchAdmin', 'BranchOwner'],
                children: [
                    {
                        path: 'topselling',
                        children: [
                            { index: true, element: <ProductReport /> },
                        ]
                    },
                    {
                        path: "financialReport",
                        permissions: ['BranchAdmin', 'BranchOwner'],
                        element: <FinancialReport />,
                    },
                ]
            },
            {
                path: "discount",
                permissions: ['BranchAdmin', 'BranchOwner'],
                children: [
                    { index: true, element: <DiscountView /> },
                    {
                        path: ':discountId',
                        children: [
                            { index: true, element: <DiscountDetail /> },
                        ]
                    }
                ]
            },
            {
                path: "transactionType",
                permissions: ['RestaurantAdmin', 'RestaurantOwner'],
                children: [
                    { index: true, element: <TransactionTypeView /> },
                    {
                        path: "add",
                        element: <TransactionTypeAdd />
                    },
                    {
                        path: ':transactionTypeId',
                        children: [
                            { index: true, element: <TransactionTypeDetail /> },
                            { path: 'edit', element: <TransactionTypeEdit /> }
                        ]
                    }
                ],
            },
            {
                path: "transactions",
                permissions: ['BranchAdmin', 'BranchOwner'],
                children: [
                    { index: true, element: <TransactionView /> },
                    {
                        path: "add",
                        element: <TransactionAdd />
                    },
                    {
                        path: ':transactionId',
                        children: [
                            { index: true, element: <TransactionDetail /> },
                            { path: 'edit', element: <TransactionEdit /> }
                        ]
                    }
                ],
            },
            {
                path: "recurring",
                permissions: ['BranchAdmin', 'BranchOwner'],
                children: [
                    { index: true, element: <RecurringExpenseView /> },
                    {
                        path: "add",
                        element: <RecurringExpenseAdd />
                    },
                    {
                        path: ':recurringExpenseId',
                        children: [
                            { index: true, element: <RecurringExpenseDetail /> },
                            { path: 'edit', element: <RecurringExpenseEdit /> }
                        ]
                    }
                ],
            },
            {
                path: "invoice",
                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                children: [
                    { path: '', element: <ViewInvoice /> },
                    { path: 'create', element: <CreateInvoice /> },
                    {
                        path: ':invoiceId',
                        children: [
                            { index: true, element: <DetailedInvoice /> },
                            { path: 'edit', element: <CreateInvoice /> }
                        ]
                    },
                    {
                        path: 'bank',
                        permissions: ['BranchAdmin', 'BranchOwner'],
                        children: [
                            { index: true, element: <BankView /> },
                            { path: 'add', element: <BankAdd /> },
                            {
                                path: ':bankId',
                                children: [
                                    { index: true, element: <BankDetail /> },
                                    { path: 'edit', element: <BankEdit /> },
                                ]
                            },
                        ]
                    },
                ]
            },
            {
                path: 'expense',
                permissions: ['RestaurantAdmin', 'RestaurantOwner'],
                children: [
                    { index: true, element: <></> },
                    {
                        path: ':expenseType',
                        children: [
                            { index: true, element: <ExpenseProductView /> },
                            { path: 'add', element: <ExpenseProductAdd /> },
                            {
                                path: ':productId',
                                children: [
                                    { index: true, element: <ExpenseProductDetail /> },
                                    { path: 'edit', element: <ExpenseProductEdit /> },
                                ]
                            },
                        ]
                    }
                ]
            },
            {
                path: "contact",
                permissions: ['RestaurantAdmin', 'RestaurantOwner'],
                children: [
                    { index: true, element: <ContactView /> },
                    {
                        path: ':contactId',
                        children: [
                            { index: true, element: <ContactDetail /> },
                        ]
                    },
                ],
            },
            {
                path: "trackOrder",
                permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager', 'BranchEmployee'],
                children: [
                    { index: true, element: <TrackOrder /> },
                    // {
                    //     path: ':contactId',
                    //     children: [
                    //         {index: true, element: <ContactDetail/>},
                    //     ]
                    // },
                ],
            },
            // {
            //     path: "building",
            //     permissions: ['RestaurantAdmin', 'RestaurantOwner'],
            //     children: [
            //         {index: true, element: <BuildingView/>},
            //         {path: 'add', element: <BuildingAdd/>},
            //         {
            //             path: ':buildingId',
            //             children: [
            //                 {index: true, element: <BuildingDetail/>},
            //                 {path: 'edit', element: <BuildingEdit/>},
            //             ]
            //         },
            //     ],
            // },
            {
                path: "profile",
                element: <Profile />,
            },
            {
                path: "setting",
                element: <Setting />
            }
        ]
    },
    {
        path: "/login",
        element:
            <Login />,
    },
    {
        path: "/vendor-dashboard/:vendorId/:scopeId",
        element: <VendorLayout />,
        children: [
            { index: true, element: <VendorLogin /> },
            { path: 'docUpload', element: <VendorDocAttach /> },
            { path: 'docHistory', element: <VendorDocHistory /> },
        ]
    },
    {
        path: "*",
        element:
            <ErrorPage />, // Catch-all for unmatched routes
    }
]
    ;
